import React, { useState } from 'react';
import { useEffectOnce } from 'react-use';

import { HOC } from '../../../utils';
import { programsDummy } from '../../_dummyData';

import { ProgramsProps } from './Programs.type';

type InjectedProps = ProgramsProps;

export const withState =
    (): HOC<InjectedProps> => (BaseComponent) => (props) => {
        const [data, setData] = useState<ProgramsProps['data']>([]);
        const [activeKey, setActiveKey] =
            useState<ProgramsProps['activeKey']>(1);

        useEffectOnce(() => {
            setData(programsDummy);
        });

        const injectedProps: InjectedProps = {
            data,
            activeKey,
            toggleList(key) {
                if (activeKey === key) {
                    setActiveKey(null);
                } else {
                    setActiveKey(key);
                }
            },
        };

        return <BaseComponent {...(props as any)} {...injectedProps} />;
    };
